import { gql } from '@apollo/client';

const getSellerLeadQuery = gql`
  query GetSellerLeadQuery($sellerInputUUID: String!) {
    seller {
      getLeadBySource(input: { source: { type: RECEPTION, id: $sellerInputUUID } }) {
        lead {
          productOfferings {
            product
            deniedAt
            denialReason
          }
        }
      }
    }
  }
`;

export default getSellerLeadQuery;
